/**
 * Get IPGeo data from cdn3 (Akamai)
 * @module
 */
var AsyncRequest = require('../../utils/async_request');
var Script = require('../../utils/script');

var SOURCE_ID = 'cdn3';

/**
 * Get the visitor's IP address when known.
 * @returns {Promise} Promise that resolves to the IP (string)
 */
exports.getIP = function(): Promise<any> {
  return AsyncRequest.makeAsyncRequest(SOURCE_ID, makeGeoIPRequest).then(function(data) {
    if (__INVARIANT__) {
      require('../../utils/invariant').isType('IPGeo', data);
    }

    return data.ip;
  });
};

/**
 * Get the visitor's GeoLocation when known.
 * @returns {Promise} Promise that resolves to the location (GeoLocation)
 */
exports.getIPDerivedGeolocation = function(): Promise<any> {
  return AsyncRequest.makeAsyncRequest(SOURCE_ID, makeGeoIPRequest).then(function(data) {
    if (__INVARIANT__) {
      require('../../utils/invariant').isType('IPGeo', data);
    }

    return data.location;
  });
};

var GEO_CDN_URL = __GEO_CDN_HOST__ + '/js/geo4.js';

/**
 * @private
 */
function makeGeoIPRequest() {
  Script.addScriptAsync(GEO_CDN_URL);
}

if (__TEST__) {
  exports.SOURCE_ID = SOURCE_ID;
  exports.CDN3_URL = GEO_CDN_URL;
  exports.makeGeoIPRequest = makeGeoIPRequest;
}



